export default __webpack_public_path__ + "static/favicon-81497fb1d7b38fc662012f8bd346cd8e.jpg";